import RoutePage from './pages/RoutePage.jsx'

export default function App() {
  return <RoutePage />
}
